module.exports = __webpack_public_path__ + "img/progress1.3e101570.png";